export const GET_PLC_SAFETY_ZONE_DEPENDENCIES = 'GET_PLC_SAFETY_ZONE_DEPENDENCIES';
export const GET_PLC_SAFETY_ZONE_DEPENDENCIES_SUCCESS = 'GET_PLC_SAFETY_ZONE_DEPENDENCIES_SUCCESS';
export const GET_PLC_SAFETY_ZONE_DEPENDENCIES_ERROR = 'GET_PLC_SAFETY_ZONE_DEPENDENCIES_ERROR';
